import { render, staticRenderFns } from "./FinSeminuevos.vue?vue&type=template&id=a7a98146&scoped=true&"
import script from "./FinSeminuevos.vue?vue&type=script&lang=js&"
export * from "./FinSeminuevos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a98146",
  null
  
)

export default component.exports